import React from 'react'
import {Accordion} from 'react-bootstrap'
import {LoanerInventoryListPage, RepairInventoryListPage, TicketListPage,} from '../../pages'

export const GlobalSearch = ({ currentKey, onChange, search }) => {
  return (
    <Accordion flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header onClick={() => onChange('0')}>
          Tickets
        </Accordion.Header>
        <Accordion.Body>
          {currentKey === '0' && <TicketListPage defaultFilters={search} />}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header onClick={() => onChange('1')}>
          Inventory
        </Accordion.Header>
        <Accordion.Body>
          {currentKey === '1' && (
            <RepairInventoryListPage defaultFilters={search} />
          )}
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header onClick={() => onChange('2')}>
          Loaner Inventory
        </Accordion.Header>
        <Accordion.Body>
          {currentKey === '2' && (
            <LoanerInventoryListPage defaultFilters={search} />
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}
